import React, { useEffect, useState, useRef } from 'react';
import { Carousel, Spin, Button, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import BannerSkeleton from './skeletons/BannerSkeleton';
import "../css/HomeSlider.css";
import { renderSafeText } from "../util/unitFormatter";
import SafeImage from "./SafeImage";
import { usePreference } from '../context/PreferenceContext';
import { useCategory } from '../context/CategoryContext';

const DEFAULT_SLIDER_IMAGES = [
    "https://images.unsplash.com/photo-1550009158-9ebf6d250400?w=1200&q=80", // Electronics/Tech
    "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=1200&q=80", // Furniture
    "https://images.unsplash.com/photo-1558981806-ec527fa84c39?w=1200&q=80", // Auto
    "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=1200&q=80", // Hardware
    "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=1200&q=80", // Appliances
];

const { Title, Paragraph } = Typography;

const CategoryHeroSlider = ({ onItemsLoaded }) => {
    const { t } = usePreference();
    const { parentCategories: categories, loading } = useCategory();
    const navigate = useNavigate();
    const carouselRef = useRef(null);

    // Same item logic as CategorySwiper
    const items = categories.map(cat => ({
        ...cat,
        onClick: () => navigate(`/category/${encodeURIComponent(cat.name)}`)
    }));

    useEffect(() => {
        if (!loading && onItemsLoaded) {
            onItemsLoaded(items.length > 0);
        }
    }, [loading, items.length, onItemsLoaded]);

    if (loading) return <div className="home-slider-container"><BannerSkeleton /></div>;
    if (items.length === 0) return null;

    const settings = {
        autoplay: true,
        autoplaySpeed: 6000,
        dots: true,
        fade: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <div className="home-slider-container">
            {/* Navigation matching HomeSlider style */}
            <button className="slider-nav slider-prev" onClick={() => carouselRef.current.prev()}>
                <IconChevronLeft size={16} />
            </button>
            <button className="slider-nav slider-next" onClick={() => carouselRef.current.next()}>
                <IconChevronRight size={16} />
            </button>

            <Carousel ref={carouselRef} {...settings}>
                {items.map((item, index) => (
                    <div className="slide-item" key={item._id} data-color-index={index % 6}>
                        <div className="slide-content" onClick={item.onClick}>
                                <div className="slide-image-wrapper" style={item.imageUrl ? { '--custom-fit': 'contain' } : {}}>
                                    <SafeImage
                                        src={item.imageUrl || DEFAULT_SLIDER_IMAGES[index % DEFAULT_SLIDER_IMAGES.length]}
                                        className={`slide-image ${item.imageUrl ? 'custom-contain' : ''}`}
                                        alt={renderSafeText(item.name)}
                                        placeholderText={renderSafeText(item.name)}
                                        variant="banner"
                                    />
                                </div>

                            <div className="slide-overlay pcu-hero-glass-overlay">
                                <div className="slide-category-badge pcu-glass-badge">
                                    <div className="slide-category-icon-wrapper">
                                        <SafeImage
                                            src={item.imageUrl || DEFAULT_SLIDER_IMAGES[index % DEFAULT_SLIDER_IMAGES.length]}
                                            className="pcu-w-100 pcu-h-100 pcu-image-cover"
                                            alt=""
                                            variant="square"
                                        />
                                    </div>
                                    <span>{item._id === 'all' ? t('nearzon_marketplace') : t('category')}</span>
                                </div>
                                <h2 className="slide-title premium-slide-title">
                                    {renderSafeText(item.name)}
                                </h2>

                                {/* <Paragraph className="slide-desc" style={{ fontSize: "14px" }}>
                                    {renderSafeText(item.description) || `${t('explore_range')} ${renderSafeText(item.name)} ${t('verified_sellers')}`}
                                </Paragraph> */}

                                <div className="slide-actions">
                                    <Button
                                        type="primary"
                                        size="large"
                                        className="premium-slide-btn"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            item.onClick();
                                        }}
                                    >
                                        SHOP NOW
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </Carousel>
        </div>
    );
};

export default CategoryHeroSlider;
